<ion-card mode="ios" class="team-card limited-card-col">
    <ion-grid class="header" lines="none">
        <ion-row>
            <ion-col size="8">
                <img [src]="getImageUrl(user?.imageUrl)" default="">
                <p class="note">
                    {{ user?.name }}<br>
                    <ng-container class="attributes" *ngIf="!hideAttributesFromUserSearchOn360">
                      {{ user.attribute1 }} - {{ user.attribute2 }}
                    </ng-container>
                </p>
            </ion-col>
            <ion-col size="4">
                <ng-container *ngIf="user.status === ProcessStatus.AllowedViewingWithWarnings 
                        || (user.status !== ProcessStatus.AllowedViewing 
                        && processConfig.skipSelectionStep 
                        && user.areaEvaluators.length > 0)">
                    <ion-button mode="ios" expand="block" color="success" (click)="confirmApproveEvaluators(user)">
                        {{ '360evaluation.approve' | translate }}
                    </ion-button>
                </ng-container>
            </ion-col>
        </ion-row>
    </ion-grid>

    <ion-card-content class="ion-no-padding">
        <ng-container *ngFor="let area of user.areaEvaluators; let areaIndex = index">
            <div class="top" [ngStyle]="{'justify-content': showAreaEvaluatorsCount? 'space-between' : 'flex-end'}">
                <h4 *ngIf="showAreaEvaluatorsCount">
                    {{ getText(area.area, 'title') | uppercase }} ({{user.areaEvaluators[areaIndex].evaluators.length}}/{{maxByArea[area.areaId]}})
                </h4>
                <ng-container
                        *ngIf="
                        (user.status === ProcessStatus.AllowedViewingWithWarnings
                        || (user.status !== ProcessStatus.AllowedViewing 
                        && processConfig.skipSelectionStep)) && !showSearchWithoutAddClick">
                    <ion-button mode="ios" expand="block" (click)="area.showSearch = true" [disabled]="area.showSearch">
                        {{ 'generic.add' | translate }}
                    </ion-button>
                </ng-container>
            </div>
            <ng-container *ngIf="(area.showSearch || showSearchWithoutAddClick) 
                                 && (user.status === ProcessStatus.AllowedViewingWithWarnings 
                                     || (
                                         user.status !== ProcessStatus.AllowedViewing 
                                         && processConfig.skipSelectionStep 
                                         && user.areaEvaluators.length > 0
                                        )
                                    )">
                <ion-card-header>
                    <ion-row>
                        <ion-col size="9">
                            <ion-searchbar mode="ios" class="section-search-custom" #userSearch
                                [placeholder]="'generic.searchByName' | translate">
                            </ion-searchbar>
                        </ion-col>
                        <ion-col size="3">
                            <div class="btn-group">
                                <ion-button text-wrap mode="ios" expand="block" slot="end"
                                    (click)="updateSearch(userSearch.value, areaIndex)">
                                    {{ 'generic.ThreeSixtyEvaluationValidationGetUsers' | translate }}
                                </ion-button>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-card-header>
                <div class="limited-users-list">
                    <ion-list class="users" *ngIf="searchUsers[areaIndex] && searchUsers[areaIndex].length > 0">
                        <ion-item *ngFor="let user of searchUsers[areaIndex]"
                            [color]="user.flags?.length > 0 ? 'danger' : 'primary' ">
                            <div class="user user-item"
                                [ngClass]="{'denied-clickable': (user.aboveSelectionLimit && isReopenedByRefusal),'clickable': (!user.aboveSelectionLimit || !isReopenedByRefusal) }"
                                (click)="selectUser(user, areaIndex)">
                                <div class=" users-container-name">
                                    <span>
                                        <b>{{ user.name }}</b>
                                        <ng-container *ngIf="!hideAttributesFromUserSearchOn360">- {{ user.attribute1 }} / {{ user.attribute2 }}</ng-container>
                                    </span>
                                    <span *ngIf="user.aboveSelectionLimit" class="warning-selection-box">
                                        <ion-icon size="small" class="bp-info" name="information-circle"
                                            style="color: #F6BD3A;"></ion-icon>
                                        &nbsp;Selecionado por {{threeSixtyEvaluationLimit || 1}}+ usuários
                                    </span>

                                </div>
                                <span *ngIf="user.flags?.length === 0" class="hoverable">
                                    ({{ '360evaluation.clickToSelect' | translate | lowercase }})
                                </span>
                                <span *ngFor="let error of user.flags" class="hoverable">
                                    ({{ error | translate }})
                                </span>
                            </div>
                        </ion-item>
                    </ion-list>
                </div>
            </ng-container>

            <ion-grid class="team">
                <ion-row class="thead">
                    <ion-col size="2"></ion-col>
                    <ion-col [size]="hideAmountTimeUserWasSelectedOn360 ? 8 : 6">
                        <ng-container *ngIf="area.evaluators.length > 0">
                            {{ 'generic.username' | translate | lowercase }}
                        </ng-container>
                    </ion-col>
                    <ion-col [size]="hideAmountTimeUserWasSelectedOn360 ? 2 : 4">
                        <ng-container *ngIf="!hideAmountTimeUserWasSelectedOn360">
                            {{ '360evaluation.selected' | translate | lowercase }}
                            <span>ⓘ</span>
                            <span class="hovered">
                                {{ '360evaluation.selectedHoverInfo' | translate }}
                            </span>
                        </ng-container>
                    </ion-col>
                </ion-row>
                <div class="limited-users-list">
                    <ion-row class="tbody" *ngFor="let evaluator of area.evaluators; let userIndex = index">
                        <ion-col size="2">
                            <img [src]="getImageUrl(evaluator?.imageUrl)" default="" class="avatar">
                        </ion-col>
                        <ion-col [size]="hideAmountTimeUserWasSelectedOn360 ? 8 : 6">
                            <h3>
                                {{ evaluator.name }}<br>
                                <ng-container *ngIf="!hideAttributesFromUserSearchOn360">{{ user.attribute1 }} / {{ user.attribute2 }}</ng-container>
                            </h3>
                        </ion-col>
                        <ion-col [size]="hideAmountTimeUserWasSelectedOn360 ? 2 : 4" class="last">
                            <ng-container *ngIf="!hideAmountTimeUserWasSelectedOn360">
                                <div class="count" [ngClass]="{
                                          'danger': evaluator.selectedCount > (showThreeSixtyEvaluationLimit ? threeSixtyEvaluationLimit : 10),
                                          'warning': showThreeSixtyEvaluationLimit ? false : ( evaluator.selectedCount > 5 && evaluator.selectedCount < 10),
                                          'ok': evaluator.selectedCount <= (showThreeSixtyEvaluationLimit ? threeSixtyEvaluationLimit : 5) 
                                        }"
                                    [title]="evaluator.selectedCount > (showThreeSixtyEvaluationLimit ? threeSixtyEvaluationLimit : 10) ? 'Acima do Limite' : ''">
                                    {{ evaluator.selectedCount }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="showThreeSixtyEvaluationLimit && hideAmountTimeUserWasSelectedOn360">
                                <div [ngClass]="{
                                          'danger': evaluator.selectedCount > threeSixtyEvaluationLimit,
                                          'ok': evaluator.selectedCount <= threeSixtyEvaluationLimit 
                                        }">
                                    {{aboveSelectionLimit ? 'Acima do Limite' : ''}}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="user.status === ProcessStatus.AllowedViewingWithWarnings 
                                || (user.status !== ProcessStatus.AllowedViewing && processConfig.skipSelectionStep)">
                                <ion-icon (click)="confirmRemoveEvaluator(areaIndex, user, userIndex)" color="danger"
                                    class="bp-delete"></ion-icon>
                            </ng-container>
                        </ion-col>
                    </ion-row>
                </div>
            </ion-grid>
        </ng-container>

        <!-- <div class="footer" *ngIf="user.status === ProcessStatus.AllowedViewingWithWarnings" >
          <ion-button mode="ios" expand="block" color="success"
            (click)="approveEvaluators(user)" >
            {{ 'generic.approve' | translate }}
          </ion-button>
        </div> -->
    </ion-card-content>
</ion-card>